import axios from "axios";

const fallbackBaseURL = process.env.NODE_ENV === "production"
  ? "/auditing/api"
  : "http://localhost:8086/api";

export const apiBaseURL = (process.env.REACT_APP_API_BASE_URL || fallbackBaseURL).replace(/\/+$/, "");
const apiTimeoutMs = Number(process.env.REACT_APP_API_TIMEOUT_MS || 15000);

const client = axios.create({
  baseURL: apiBaseURL,
  timeout: Number.isFinite(apiTimeoutMs) && apiTimeoutMs > 0 ? apiTimeoutMs : 15000
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const shouldSkipAuthRedirect = Boolean(
      error?.config?.skipAuthRedirect
      || error?.config?.metadata?.skipAuthRedirect
    );

    if (error?.response?.status === 401 && !shouldSkipAuthRedirect) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      localStorage.removeItem("active_website_id");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default client;
